<template>
  <div class="myMenu">
    <div class="menuDiv" @click="monthCard()">
      集团用户-月卡续费
    </div>
    <div class="menuDiv" @click="invoice()">
      集团用户-电子发票
    </div>
  </div>
</template>

<script>
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    data() {
      return {};
    },
    methods: {
      //集团用户-月卡续费
      monthCard() {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?scope=snsapi_base&response_type=code&redirect_uri=http%3A%2F%2Fmanager.ctpark.cn%2Fappclient%2Fwxpub%2Fv1%2FmonthCardRewal.html&state=STATE%23wechat_redirect&appid=wxa88a250b4e28abd8";
      },
      //集团用户-电子发票
      invoice() {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?scope=snsapi_base&response_type=code&redirect_uri=http%3A%2F%2Fmanager.ctpark.cn%2Fappclient%2Fapp%2Finvoice%2FinvoiceHome.html&state=STATE%23wechat_redirect&appid=wxa88a250b4e28abd8";
      }
    },
    created() {}
  };
</script>

<style>
  .myMenu {
    width: 100%;
    height: 100%;
    text-align: center;
    margin: 25% 0px;
  }

  body {
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .menuDiv {
    border: 2px solid wheat;
    margin: 50px auto;
    width: 85%;
    height: 150px;
    line-height: 150px;
    font-size: 20px;
    font-weight: bold;
    background: lightgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/myMenu.vue